import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import Exchange from "@/modules/action-points/components/Exchange.vue";
import CurrencyLayout from "./CurrencyLayout.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'ExchangePage',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(CurrencyLayout, null, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('exchange_coins')), 1)]),
        default: _withCtx(() => [_createVNode(Exchange)]),
        _: 1
      });
    };
  }
});